import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { DiagramDataModel, FlangeDimensionModel, GasketModel } from '../Modules/informate/models';
import { FullUserData } from '../Modules/management/models/organization/fullUserData.model';
import { Communication } from '../Modules/settings/models/profile/communication.model';
import { BoltDimensionModel } from '../Modules/informate/models';
import { Organization } from '../Modules/management/models/organization/organization.model';
import { InstanceModel, TaggedItemType } from '../Modules/management/models/instance/instance.model';
import { InstanceType } from '../Modules/management/models/instance/instance.model';
import { ToolOutput } from '../Modules/informate/models/calculationModels';
import { CalculationType } from '../Modules/informate/enums/calculation-type.enum';
import { ApprovalRule } from '../Modules/settings/models/common/setting-area.model';

@Injectable({
    providedIn: 'root',
})
export class GlobalEmittersService {
    currentOrg: BehaviorSubject<string> = new BehaviorSubject(null);
    currentOrgId: BehaviorSubject<string> = new BehaviorSubject(null);
    currentInstanceName: BehaviorSubject<string> = new BehaviorSubject(null);
    currentInstanceId: BehaviorSubject<string> = new BehaviorSubject(null);
    currentInstanceTypeId: BehaviorSubject<string> = new BehaviorSubject(null);
    currentLicenseInstanceTypeIndex: BehaviorSubject<number> = new BehaviorSubject(null);
    isLicenseValid: BehaviorSubject<boolean> = new BehaviorSubject(null);
    refreshMatrix: BehaviorSubject<boolean> = new BehaviorSubject(null);
    refreshContentGeneralSetting: Subject<boolean> = new Subject();
    lubricantUnitTighteningSpecification = new Subject<{ isEvent: boolean; dropdownValue: string }>();
    currentCalculationType = new BehaviorSubject<number>(-1);
    openControlProcedurePanel = new Subject<boolean>();
    selectedTools: BehaviorSubject<string> = new BehaviorSubject(null);
    refreshWarnings: BehaviorSubject<boolean> = new BehaviorSubject(null);
    profileDetails: BehaviorSubject<FullUserData> = new BehaviorSubject(null);
    isUserDefaultsLoaded: BehaviorSubject<boolean> = new BehaviorSubject(null);
    refreshEmailAndNoti: BehaviorSubject<boolean> = new BehaviorSubject(null);
    hideInstanceLogoutOption: BehaviorSubject<boolean> = new BehaviorSubject(null);
    hideOrgLogoutOption: BehaviorSubject<boolean> = new BehaviorSubject(null);
    isCalculationHappen: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    initiateInterval: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    addCommunication: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    refreshLoader: Subject<boolean> = new Subject<boolean>();

    addCommunicationEvent: Subject<Communication> = new Subject<Communication>();
    communicationList: BehaviorSubject<Communication[]> = new BehaviorSubject<Communication[]>([]);

    sharedContentType: Subject<string> = new Subject<string>();
    isLanguageSetUp: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    selectedCalcType: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    selectedGasket: BehaviorSubject<GasketModel> = new BehaviorSubject<GasketModel>(null);

    processInfoForm: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    standardInputForm: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    customInputForm: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    tighteningProcedureForm: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    toolsFormGroup: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    clampInputFormGroup: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    engineerJointIFormGroup: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    dbSelectLookUpSaveEvent = new Subject<boolean>();
    materialAliasSaveEvent = new Subject<boolean>();
    pipeCodesSaveEvent = new Subject<boolean>();
    passPercentageSaveEvent = new Subject<boolean>();
    barcodeSaveEvent = new Subject<boolean>();
    rulesSaveEvent = new Subject<boolean>();
    updateStatus = new BehaviorSubject<any>(null);
    deliveryGroupUpdateEvent = new Subject<any[]>();

    tighteningMethod: Subject<string> = new Subject<string>();
    flangeDimension: Subject<FlangeDimensionModel[]> = new Subject<FlangeDimensionModel[]>();
    updateStandardFlangeHeader: Subject<boolean> = new Subject<boolean>();

    instanceCreated: Subject<boolean> = new Subject<boolean>();
    LoadCalculation: Subject<boolean> = new Subject<boolean>();
    ManufactureName: BehaviorSubject<string> = new BehaviorSubject<string>('');
    ToolSelectedId: BehaviorSubject<string> = new BehaviorSubject<string>('');
    boltSizeList: BehaviorSubject<BoltDimensionModel[]> = new BehaviorSubject<BoltDimensionModel[]>(null);
    savePersonalDetails: Subject<boolean> = new Subject<boolean>();
    saveEmailNotiDetails: Subject<boolean> = new Subject<boolean>();

    taggedItemTypeEvent: Subject<TaggedItemType> = new Subject<TaggedItemType>();
    triggerVersionAdd: Subject<boolean> = new Subject<boolean>();
    activeTaggedItemType: Subject<TaggedItemType> = new Subject<TaggedItemType>();
    taggedItemNamesList: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
    taggedItemAllowEdit: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    currentOrganization: Subject<Organization> = new Subject<Organization>();
    currentInstance: Subject<InstanceModel> = new Subject<InstanceModel>();
    currentInstanceType: Subject<InstanceType> = new Subject<InstanceType>();

    refreshTools: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    createPdfViewer: Subject<string> = new Subject<string>();
    calculationResult: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    calculationResultUpdate: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    isSaveFromToolsubscription: BehaviorSubject<any> = new BehaviorSubject<any>(null);
    diagramInfo: BehaviorSubject<DiagramDataModel> = new BehaviorSubject<DiagramDataModel>(null);
    SelectedToolData: Subject<ToolOutput> = new Subject<ToolOutput>();
    documentListEvent: BehaviorSubject<string> = new BehaviorSubject<string>(null);

    CalculationType: BehaviorSubject<CalculationType> = new BehaviorSubject<CalculationType>(null);
    IsMoveSuccess: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    ShowFlangeDetailsTab: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    setSelectedTab: BehaviorSubject<number> = new BehaviorSubject<number>(null);
    toolsData: BehaviorSubject<ToolOutput[]> = new BehaviorSubject<ToolOutput[]>(null);
    selectedGasketId: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    unitUpdated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    selectedTool: ToolOutput;

    isrefreshProjectDetails: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    refreshpipespec: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(null);
    documentFormData: Subject<any> = new Subject<any>();

    contactLinkClick: Subject<boolean> = new Subject<boolean>();
    torqueSequencename: Subject<string> = new Subject<string>();

    getCommunicationListSubject: Subject<boolean> = new Subject<boolean>();
    saveFromFlangeDetails: BehaviorSubject<boolean> = new BehaviorSubject<any>(false);

    pipeCodeReCalculate: Subject<boolean> = new Subject<boolean>();

    useHiearchyClick: Subject<boolean> = new Subject<boolean>();
    isIdmsPreferenceSettingUpdated: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    refreshOrgName: Subject<boolean> = new Subject<boolean>();
    updateSelectedApprovalRule = new Subject<ApprovalRule>();
    isToolSelected: Subject<boolean> = new Subject<boolean>();
    RuleSaveDisable: boolean = false;
    resetPage: Subject<boolean> = new Subject<boolean>();
}
